import React, { Component } from "react";
import { Alert } from "react-bootstrap";
import './AutoDismissAlert.css'
import { FaCheckCircle, FaExclamationCircle, FaInfoCircle, FaTimesCircle } from "react-icons/fa";

class AutoDismissAlert extends Component {
    constructor(props) {
        super(props);
        this.state = { visible: true };
    }

    componentDidMount() {
        this.timer = setTimeout(() => {
            this.setState({ visible: false });
            if (this.props.onClose) {
                this.props.onClose();
            }
        }, this.props.duration || 3000);
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    render() {
        const { type } = this.props;

        const icons = {
            success: <FaCheckCircle color="green" size={16} className="icon-spacing-right"/>,
            danger: <FaTimesCircle color="red" className="icon-spacing-right"/>,
            warning: <FaExclamationCircle color="yellow" className="icon-spacing-right"/>,
            info: <FaInfoCircle color="blue" className="icon-spacing-right"/>,
        };

        const borderColors = {
            success: '#B7EB8F',
            danger: 'red',
            warning: 'yellow',
            info: 'blue'
        }

        if (!this.state.visible) return null;

        const position = this.props.position || 'bottom'

        return (
            <Alert
                bsStyle={this.props.type || "info"}
                className={`auto-dismiss-alert ${position}`}
                style={{borderColor: borderColors[type]}}
            >
                {icons[type] || icons.info}
                {this.props.message}
            </Alert>
        );
    }
}

export default AutoDismissAlert;
